import { axios } from '@ben/api/axios';
import { isNil } from 'lodash';

interface ComponentKey {
  id: number;
  key: string;
  [key: string]: unknown;
}

interface ComponentKeysResponse {
  count?: number;
  next: string | null;
  previous?: string | null;
  results: ComponentKey[];
}

export const getComponentKeys = async (
  searchKey?: string,
  options?: { page?: number; pageSize?: number }
): Promise<ComponentKeysResponse> => {
  let url = `component-keys/?search=${searchKey ?? ''}`;
  if (options?.pageSize) {
    url += `&page_size=${options.pageSize}`;
  }
  if (options?.page) {
    url += `&page=${options.page}`;
  }
  const response = await axios.get<ComponentKeysResponse>(url);
  return response.data;
};

const RESOLVE_PAGE_SIZE = 100;

export const resolveComponentKeyById = async (
  id: number
): Promise<ComponentKey | undefined> => {
  let page = 1;

  while (true) {
    const data = await getComponentKeys('', {
      page,
      pageSize: RESOLVE_PAGE_SIZE,
    });
    const found = data.results.find((componentKey) => componentKey.id === id);
    if (found) {
      return found;
    }
    if (isNil(data.next)) {
      return undefined;
    }
    page += 1;
  }
};

export const createComponentKey = async (
  key: string
): Promise<ComponentKey> => {
  const response = await axios.post<ComponentKey>('component-keys/', { key });
  return response.data;
};
